import React, { useState, useRef } from 'react'
import { Button, Collapse } from 'antd'
import { DisplayDate } from '../../../components/_utils/appUtils'
import ReceiveDateDrawer from '../reviewer/editSelectReceiveDate'
import { RowTable } from './RowTable'

const { Panel } = Collapse
const ReviewedArticles = (props) => {
  let { article } = props
  let { underReviewDetails } = article
  let [receiveDateDrawerVisible, setReceiveDateDrawerVisible] = useState(false)
  let [reviewerId, setReviewerId] = useState('')
  let headerTitle = `Reviewed Manuscript ${underReviewDetails && underReviewDetails.receiveDate ? `(${DisplayDate(underReviewDetails.receiveDate)})` : ''}`
  const table = useRef()
  let events = {
    reloadTable: () => {
      table.current.reload()
    },
    showAndHideReceiveDate: (value, id = '') => {
      setReceiveDateDrawerVisible(value)
      setReviewerId(id)
    }
  }
  let getExtraButton = () => {
    return (
      <React.Fragment>
        {underReviewDetails && underReviewDetails.receiveDate ?
          <Button type={'primary'} size={'small'} onClick={(event) => {
            events.showAndHideReceiveDate(true)
            event.stopPropagation()
          }}>Edit</Button> : null}
      </React.Fragment>
    )
  }


  return (
    <div>
      <Collapse expandIconPosition={'right'} defaultActiveKey={['1']}>
        <Panel header={headerTitle} key='1' extra={getExtraButton()}>
          <div className={'tableBox striped'}>
            <RowTable title={'Comments Attachment'} value={
              underReviewDetails.commentsAttachment && underReviewDetails.commentsAttachment.path ?
                <a download className='downloadLink' target={'_blank'}
                   href={underReviewDetails.commentsAttachment.path}>Download</a> : 'No Attachment'
            } />
            <RowTable title={'Article Attachment'} value={
              underReviewDetails.articleAttachment && underReviewDetails.articleAttachment.path ?
                <a download className='downloadLink' target={'_blank'}
                   href={underReviewDetails.articleAttachment.path}>Download</a> : 'No Attachment'
            } />
            <RowTable title={'See Article Again'} value={
              underReviewDetails ?
                <p>{underReviewDetails.articleSeeAgain ? 'true' : 'false'}</p> : null
            } />
            {article.underReviewDetails && article.underReviewDetails.commentsAttachment2 && article.underReviewDetails.commentsAttachment2.path ? (
              <RowTable title={'Second Comments Attachment'} value={
                <a download className='downloadLink' target={'_blank'}
                   href={article.underReviewDetails.commentsAttachment2.path}>Download</a>
              } />
            ) : null}
            {article.underReviewDetails && article.underReviewDetails.articleAttachment2 && article.underReviewDetails.articleAttachment2.path ? (
              <RowTable title={'Second Article Attachment'} value={
                <a download className='downloadLink' target={'_blank'}
                   href={article.underReviewDetails.articleAttachment2.path}>Download</a>
              } />
            ) : null}
          </div>
        </Panel>
      </Collapse>
      {receiveDateDrawerVisible ? <ReceiveDateDrawer
        visible={receiveDateDrawerVisible}
        reviewerId={reviewerId}
        article={article}
        onClose={() => events.showAndHideReceiveDate(false)}
      /> : null}
    </div>
  )
}

export default ReviewedArticles
